import React from 'react';

import { Button, Text, VStack, theme } from '@squire/ui';

import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { ChooseServiceErrorProps } from './types';

const ChooseServiceError: React.FC<ChooseServiceErrorProps> = ({
  resetErrorBoundary,
  error: _error,
  testID = 'choose-service-error',
  style,
  ...props
}) => {
  const { t } = useScreenTranslations('ChooseServiceScreen');

  return (
    <VStack
      flex
      space={theme.spacing[4]}
      centerHorizontal
      centerVertical
      style={[styles.container, style]}
      testID={testID}
      {...props}
    >
      <Text variant="l" color="textNegative" align="center">
        {t('error.title')}
      </Text>
      <Text variant="m" color="textSecondary" align="center">
        {t('error.message')}
      </Text>
      {resetErrorBoundary && (
        <Button
          onPress={resetErrorBoundary}
          variant="primary"
          style={styles.tryAgainButton}
        >
          {t('error.tryAgain')}
        </Button>
      )}
    </VStack>
  );
};

ChooseServiceError.displayName = 'ChooseServiceError';

export { ChooseServiceError };
